export default __webpack_public_path__ + "static/media/map.3e068680.svg";